// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__tRJup","icon":"SortAdornment_icon__1x9lr","up":"SortAdornment_up__yjATy","down":"SortAdornment_down__2Koy7","active":"SortAdornment_active__QjDSN"};